export default __webpack_public_path__ + "static/man-fff248b0980dcd5cb9436fe618a6835f.png";